import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { TableCollection as $788781baa30117fa$export$596e1b2e2cf93690 } from "./TableCollection.module.js";
import { useGridState as $1YSEb$useGridState } from "@react-stately/grid";
import { useState as $1YSEb$useState, useMemo as $1YSEb$useMemo, useCallback as $1YSEb$useCallback } from "react";
import { useCollection as $1YSEb$useCollection } from "@react-stately/collections";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

var $4a0dd036d492cee4$var$OPPOSITE_SORT_DIRECTION = {
  ascending: 'descending',
  descending: 'ascending'
};

function $4a0dd036d492cee4$export$907bcc6c48325fd6(props) {
  var _ref = (0, $1YSEb$useState)(false),
      _ref2 = _slicedToArray(_ref, 2),
      isKeyboardNavigationDisabled = _ref2[0],
      setKeyboardNavigationDisabled = _ref2[1];

  var _props$selectionMode = props.selectionMode,
      selectionMode = _props$selectionMode === void 0 ? 'none' : _props$selectionMode,
      showSelectionCheckboxes = props.showSelectionCheckboxes,
      showDragButtons = props.showDragButtons;
  var context = (0, $1YSEb$useMemo)(function () {
    return {
      showSelectionCheckboxes: showSelectionCheckboxes && selectionMode !== 'none',
      showDragButtons: showDragButtons,
      selectionMode: selectionMode,
      columns: []
    };
  }, [props.children, showSelectionCheckboxes, selectionMode, showDragButtons]);
  var collection = (0, $1YSEb$useCollection)(props, (0, $1YSEb$useCallback)(function (nodes) {
    return new (0, $788781baa30117fa$export$596e1b2e2cf93690)(nodes, null, context);
  }, [context]), context);

  var _ref3 = (0, $1YSEb$useGridState)(_objectSpread(_objectSpread({}, props), {}, {
    collection: collection,
    disabledBehavior: props.disabledBehavior || 'selection'
  })),
      disabledKeys = _ref3.disabledKeys,
      selectionManager = _ref3.selectionManager;

  var _props_sortDescriptor;

  return {
    collection: collection,
    disabledKeys: disabledKeys,
    selectionManager: selectionManager,
    showSelectionCheckboxes: props.showSelectionCheckboxes || false,
    sortDescriptor: (_props_sortDescriptor = props.sortDescriptor) !== null && _props_sortDescriptor !== void 0 ? _props_sortDescriptor : null,
    isKeyboardNavigationDisabled: collection.size === 0 || isKeyboardNavigationDisabled,
    setKeyboardNavigationDisabled: setKeyboardNavigationDisabled,
    sort: function sort(columnKey, direction) {
      var _props_sortDescriptor, _props_onSortChange;

      (_props_onSortChange = props.onSortChange) === null || _props_onSortChange === void 0 ? void 0 : _props_onSortChange.call(props, {
        column: columnKey,
        direction: direction !== null && direction !== void 0 ? direction : ((_props_sortDescriptor = props.sortDescriptor) === null || _props_sortDescriptor === void 0 ? void 0 : _props_sortDescriptor.column) === columnKey ? $4a0dd036d492cee4$var$OPPOSITE_SORT_DIRECTION[props.sortDescriptor.direction] : 'ascending'
      });
    }
  };
}

export { $4a0dd036d492cee4$export$907bcc6c48325fd6 as useTableState };